// GLOBAL JS
// MOBILE MENU OPEN - HAMBURGER ANIMATION
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.getElementById('hamburger-toggle');
  const mobileNav = document.getElementById('mobile-menu');
  const htmlElement = document.documentElement;

  mobileNav.classList.add('menu-loaded');
  
  menuToggle.addEventListener('click', function() {
    mobileNav.classList.toggle('active');
    menuToggle.classList.toggle('active');
    menuToggle.classList.toggle('active-close');
    htmlElement.classList.toggle('overflow-hidden');
  });
});

// Localization form JavaScript
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

// FIX THIS AS IT FUCKS WITH NON ANCHOR TAG LINKS
// Smooth scroll and removing the #tag from the URL Bar
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    document.querySelector(targetId).scrollIntoView({
      behavior: 'smooth'
    });

    // Remove the hash from URL after scrolling
    history.pushState("", document.title, window.location.pathname + window.location.search);
  });
});

// Getting header height
function setHeaderHeightVariable() {
  const headerSections = document.querySelectorAll(".shopify-section-group-header-group");
  if (headerSections.length > 0) {
    // batch DOM read
    const heights = Array.from(headerSections, section => section.offsetHeight);
    const totalHeight = heights.reduce((sum, h) => sum + h, 0);
    // single DOM write
    document.documentElement.style.setProperty('--header-group-height', totalHeight + "px");
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', setHeaderHeightVariable);

// Run on window resize to handle responsive changes
window.addEventListener('resize', debounce(setHeaderHeightVariable, 100));

// Debounce function to limit resize event calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Global Accordion System
// document.addEventListener('DOMContentLoaded', function() {
//   const accordionHeaders = document.querySelectorAll('.accordion-header');

//   accordionHeaders.forEach(function(header) {
//     header.addEventListener('click', function() {
//       const accordionItem = header.closest('.accordion-item');
//       const content = accordionItem.querySelector('.accordion-content');
//       const isOpen = accordionItem.classList.contains('open');

//       // Close other open accordions
//       document.querySelectorAll('.accordion-item.open').forEach(function(openItem) {
//         if (openItem !== accordionItem) {
//           closeAccordion(openItem);
//         }
//       });

//       // Toggle current accordion
//       if (!isOpen) {
//         openAccordion(accordionItem, header, content);
//       } else {
//         closeAccordion(accordionItem);
//       }
//     });

//     // Keyboard accessibility
//     header.addEventListener('keydown', function(e) {
//       if (e.key === 'Enter' || e.key === ' ') {
//         e.preventDefault();
//         header.click();
//       }
//     });
//   });

//   function openAccordion(item, header, content) {
//     item.classList.add('open');
//     header.setAttribute('aria-expanded', 'true');
//     content.style.maxHeight = content.scrollHeight + "px";
//   }

//   function closeAccordion(item) {
//     item.classList.remove('open');
//     const header = item.querySelector('.accordion-header');
//     const content = item.querySelector('.accordion-content');
    
//     if (header) header.setAttribute('aria-expanded', 'false');
//     if (content) content.style.maxHeight = '0';
//   }
// });

// GLOBAL ACCORDION SYSTEM THAT MOVED TO TOP OF OPEN WHEN CLICKED - REPLACE WITH THE ONE BELOW THAT IS USED FOR HEADER MOBILE MENU??
// document.addEventListener('DOMContentLoaded', function() {
//   const accordionHeaders = document.querySelectorAll('.accordion-header');

//   accordionHeaders.forEach(function(header) {
//     header.addEventListener('click', function(e) {
//       const accordionItem = header.closest('.accordion-item');
//       const isFooterItem = accordionItem.classList.contains('footer-accordion-item');
//       const isMobileItem = accordionItem.classList.contains('mobile-menu-item');
      
//       // Footer accordion only works on mobile
//       if (isFooterItem && window.innerWidth > 768) return;
      
//       const index = header.getAttribute('data-index');
//       const content = accordionItem.querySelector('.accordion-content[data-submenu-index="' + index + '"]');
//       const isOpen = accordionItem.classList.contains('open');
      
//       // Handle mobile menu navigation logic
//       if (isMobileItem) {
//         const parentLink = header.querySelector('.mobile-menu-link');
//         const isLink = parentLink && parentLink.tagName.toLowerCase() === 'a' && 
//                       parentLink.getAttribute('href') && parentLink.getAttribute('href') !== '#';
        
//         if (isOpen && parentLink && e.target === parentLink && isLink) {
//           return; // Allow navigation
//         }
//         if (!isOpen && parentLink && e.target === parentLink && isLink) {
//           e.preventDefault(); // Prevent navigation, open accordion first
//         }
//       }

//       // Close other open accordions in the same context
//       const contextSelector = isFooterItem ? '.footer-accordion-item' : '.accordion-item';
//       document.querySelectorAll(contextSelector + '.open').forEach(function(openItem) {
//         if (openItem !== accordionItem) {
//           openItem.classList.remove('open');
//           const openHeader = openItem.querySelector('.accordion-header');
//           if (openHeader) openHeader.setAttribute('aria-expanded', 'false');
//           const openContent = openItem.querySelector('.accordion-content');
//           if (openContent) {
//             openContent.style.maxHeight = '0';
//           }
//         }
//       });

//       // Toggle current accordion
//       if (!isOpen) {
//         accordionItem.classList.add('open');
//         header.setAttribute('aria-expanded', 'true');
//         content.style.maxHeight = content.scrollHeight + "px";
        
//         // Scroll to the top of the accordion header on mobile
//         if (window.innerWidth <= 768) {
//           setTimeout(function() {
//             header.scrollIntoView({
//               behavior: 'smooth',
//               block: 'start'
//             });
//           }, 300); // Small delay to allow the accordion to start opening
//         }
//       } else {
//         accordionItem.classList.remove('open');
//         header.setAttribute('aria-expanded', 'false');
//         content.style.maxHeight = '0';
//       }
//     });

//     // Keyboard accessibility
//     header.addEventListener('keydown', function(e) {
//       const accordionItem = header.closest('.accordion-item');
//       const isFooterItem = accordionItem.classList.contains('footer-accordion-item');
      
//       if (isFooterItem && window.innerWidth > 768) return;
      
//       if (e.key === 'Enter' || e.key === ' ') {
//         e.preventDefault();
//         header.click();
//       }
//     });
//   });

//   // Reset footer accordion state on window resize
//   window.addEventListener('resize', function() {
//     if (window.innerWidth > 768) {
//       document.querySelectorAll('.footer-accordion-item').forEach(function(item) {
//         item.classList.remove('open');
//         const header = item.querySelector('.accordion-header');
//         if (header) header.setAttribute('aria-expanded', 'false');
//         const content = item.querySelector('.accordion-content');
//         if (content) {
//           content.style.maxHeight = 'none';
//         }
//       });
//     } else {
//       // Reset to closed state on mobile
//       document.querySelectorAll('.footer-accordion-item').forEach(function(item) {
//         if (!item.classList.contains('open')) {
//           const content = item.querySelector('.accordion-content');
//           if (content) {
//             content.style.maxHeight = '0';
//           }
//         }
//       });
//     }
//   });
// });

// DESKTOP NAV DROPDOWN
document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.menu-item');
  let timeouts = {};
  
  menuItems.forEach(item => {
    const dropdown = item.querySelector('.dropdown');
    const childItems = item.querySelectorAll('.child-item');
    
    // Parent → Child with 150ms close delay
    const showDropdown = () => dropdown?.classList.add('show');
    const hideDropdown = () => {
      clearTimeout(timeouts.dropdown);
      timeouts.dropdown = setTimeout(() => dropdown?.classList.remove('show'), 150);
    };
    
    item.addEventListener('mouseenter', showDropdown);
    item.addEventListener('mouseleave', hideDropdown);
    
    // Child → Grandchild with delay
    childItems.forEach(child => {
      const panel = child.querySelector('.grandchildren-panel');
      if (panel) {
        const showPanel = () => panel.classList.add('show');
        const hidePanel = () => {
          clearTimeout(timeouts.panel);
          timeouts.panel = setTimeout(() => panel.classList.remove('show'), 150);
        };
        
        child.addEventListener('mouseenter', showPanel);
        child.addEventListener('mouseleave', hidePanel);
      }
    });
  });
});

// MOBILE MENU ACCORDION - CHANGE TO NEW GLOBAL?
// Global Accordion System (Enhanced Debug Version)
// Supports nested + single-open mode via data-accordion-single="true" or .accordion-single class
document.addEventListener('click', function(e) {
  const toggle = e.target.closest('.accordion-toggle');
  if (!toggle) return;
  
  console.log('🎯 Accordion toggle clicked'); // Debug helper

  const header = toggle.closest('.accordion-header');
  if (!header) return;

  const item = header.closest('.accordion-item');
  if (!item) return;

  const panel = header.nextElementSibling;
  if (!panel || !panel.classList.contains('accordion-panel')) return;

  const isOpen = toggle.classList.contains('is-open');
  console.log('📂 Current state:', isOpen ? 'closing' : 'opening'); // Debug

  // Find group container (parent UL or .accordion-inner)
  const group = item.parentElement;
  const singleMode = group.classList.contains('accordion-single') || 
                     group.closest('[data-accordion-single="true"]') ||
                     group.closest('.accordion-single');

  if (!isOpen) {
    // SINGLE OPEN MODE: Close siblings at same level
    if (singleMode) {
      console.log('🔒 Single mode: closing siblings'); // Debug
      const siblingItems = group.querySelectorAll('.accordion-item');
      siblingItems.forEach(function(sibling) {
        if (sibling === item) return;
        
        const siblingToggle = sibling.querySelector('.accordion-toggle');
        const siblingPanel = sibling.querySelector('.accordion-panel');
        
        if (siblingToggle && siblingPanel) {
          siblingToggle.classList.remove('is-open');
          siblingPanel.classList.remove('is-open');
        }
      });
    }

    // Open this one
    toggle.classList.add('is-open');
    panel.classList.add('is-open');
    console.log('✅ Opened'); // Debug
  } else {
    // Close this one
    toggle.classList.remove('is-open');
    panel.classList.remove('is-open');
    console.log('❌ Closed'); // Debug
  }
});


// ============================================
// Cart State Management
// ============================================

let cartUpdateInProgress = false;

// Get current cart state
async function getCart() {
  const response = await fetch(window.Shopify.routes.root + 'cart.js');
  return response.json();
}

// ============================================
// Update Cart UI - Targeted Updates Only
// ============================================

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
  });
}

function updateCartTotals(cart) {
  // Update all total price elements using your formatMoney function
  document.querySelectorAll('[data-cart-total]').forEach(el => {
    el.textContent = Shopify.formatMoney(cart.total_price, window.money_format);
  });
  
  // Update discounts if they exist
  const discountContainers = document.querySelectorAll('[data-cart-discounts]');
  discountContainers.forEach(container => {
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      let discountsHTML = '';
      cart.cart_level_discount_applications.forEach(discount => {
        discountsHTML += `
          <div class="cart-discount">
            <span>${discount.title}</span>
            <span>-${Shopify.formatMoney(discount.total_allocated_amount, window.money_format)}</span>
          </div>
        `;
      });
      container.innerHTML = discountsHTML;
      container.style.display = 'block';
    } else {
      container.innerHTML = '';
      container.style.display = 'none';
    }
  });
}

function updateItemPrice(lineKey, cart) { 
  const cartItem = document.querySelector(`[data-line-key="${lineKey}"]`);
  if (!cartItem) return;
  
  // Find item by key (not index)
  const item = cart.items.find(item => item.key === lineKey);
  if (!item) return;
  
  const priceContainer = cartItem.querySelector('.cart-item__price');
  if (!priceContainer) return;
  
  const hasDiscount = item.original_line_price !== item.final_line_price;
  
  let originalPriceEl = priceContainer.querySelector('.cart-item__price--original');
  let finalPriceEl = priceContainer.querySelector('.cart-item__price--final');
  
  if (hasDiscount) {
    if (!originalPriceEl) {
      originalPriceEl = document.createElement('span');
      originalPriceEl.className = 'cart-item__price--original';
      priceContainer.insertBefore(originalPriceEl, finalPriceEl || null);
    }
    originalPriceEl.textContent = Shopify.formatMoney(item.original_line_price, window.money_format);
  } else {
    if (originalPriceEl) originalPriceEl.remove();
  }
  
  if (!finalPriceEl) {
    finalPriceEl = document.createElement('span');
    finalPriceEl.className = 'cart-item__price--final';
    priceContainer.appendChild(finalPriceEl);
  }
  finalPriceEl.textContent = Shopify.formatMoney(item.final_line_price, window.money_format);
}


// ============================================
// Slide Cart Controls
// ============================================

function openSlideCart() {
  const slideCart = document.getElementById('slideCart');
  if (!slideCart) return;
  
  slideCart.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  
  const closeButton = slideCart.querySelector('[data-slide-cart-close]');
  closeButton?.focus();
  
  const cartToggle = document.querySelector('[data-cart-toggle]');
  if (cartToggle) {
    cartToggle.setAttribute('aria-expanded', 'true');
  }
}

function closeSlideCart() {
  const slideCart = document.getElementById('slideCart');
  if (!slideCart) return;
  
  slideCart.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  
  const cartToggle = document.querySelector('[data-cart-toggle]');
  if (cartToggle) {
    cartToggle.setAttribute('aria-expanded', 'false');
  }
}

// ============================================
// Quantity Changes & Remove Items
// ============================================

async function changeCartQuantityByKey(lineKey, quantity) {
  if (cartUpdateInProgress) return;
  
  const cartItem = document.querySelector(`[data-line-key="${lineKey}"]`);
  if (!cartItem) return;
  
  try {
    cartUpdateInProgress = true;
    
    if (quantity === 0) {
      cartItem.style.opacity = '0.5';
      cartItem.style.pointerEvents = 'none';
    }
    
    // CRITICAL: Fetch CURRENT cart to map key to current line #
    const cart = await getCart();
    const currentLineIndex = cart.items.findIndex(item => item.key === lineKey);
    if (currentLineIndex === -1) {
      throw new Error(`Item key ${lineKey} not found in cart`);
    }
    const currentLine = currentLineIndex + 1;  // Convert 0-based index to 1-based line

    console.log('SUCCESS: Mapped key', lineKey, 'to line', currentLine);  // DEBUG
    
    // Update via current line
    const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: currentLine, quantity })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update cart');
    }
    
    // After successful response:
    const updatedCart = await response.json();
    const updatedItem = updatedCart.items.find(item => item.key === lineKey);
    
    if (quantity === 0) {
      cartItem.remove();
      if (updatedCart.item_count === 0) {
        const cartItemsContainer = document.querySelector('[data-cart-items]');
        if (cartItemsContainer) {
          cartItemsContainer.innerHTML = `<div class="cart-empty"><p>Your cart is empty</p></div>`;
        }
        closeSlideCart();
      }
    } else if (updatedItem && updatedItem.quantity !== quantity) {
      // DETECTED: Inventory limit hit (requested 14, got 10)
      
      // Update UI to match actual qty
      const quantityInput = cartItem.querySelector('[data-quantity-input]');
      quantityInput.value = updatedItem.quantity;
      
      // Show specific notice
      const notice = document.createElement('div');
      notice.className = 'cart-item__inventory-notice notice';
      notice.style.cssText = 'background: #eef; color: #336; padding: 8px 12px; border-radius: 4px; margin: 8px 0; border-left: 3px solid #66f;';
      notice.innerHTML = `
        <strong>Inventory limited:</strong> Updated to ${updatedItem.quantity} (max available)
        <button onclick="this.parentNode.remove()" style="float:right; background:none; border:none; color:#336; cursor:pointer;">×</button>
      `;
      
      cartItem.insertBefore(notice, cartItem.querySelector('.cart-item__actions'));
      
      // Update buttons
      const minusBtn = cartItem.querySelector('.quantity-btn--minus');
      minusBtn.disabled = updatedItem.quantity <= 1;
      minusBtn.dataset.quantity = updatedItem.quantity - 1;
      
      const plusBtn = cartItem.querySelector('.quantity-btn--plus');
      plusBtn.dataset.quantity = updatedItem.quantity + 1;  // Still allow +1 attempt
      
      // Update price
      updateItemPrice(lineKey, updatedCart);
      
    } else {
      // Update DOM with new data (no refresh needed)
      const quantityInput = cartItem.querySelector('[data-quantity-input]');
      if (quantityInput) quantityInput.value = quantity;
      
      const minusBtn = cartItem.querySelector('.quantity-btn--minus');
      if (minusBtn) {
        minusBtn.disabled = quantity <= 1;
        minusBtn.dataset.quantity = quantity - 1;
      }
      
      const plusBtn = cartItem.querySelector('.quantity-btn--plus');
      if (plusBtn) plusBtn.dataset.quantity = quantity + 1;
      
      // Update price with fresh cart data
      updateItemPrice(lineKey, updatedCart);
    }
    
    // Global updates
    updateCartCount(updatedCart.item_count);
    updateCartTotals(updatedCart);
    
  } catch (error) {
  console.error('Error changing quantity:', error);
  
  // Parse Shopify inventory errors
  const errorMessage = error.message;
  let itemNotice = '';
  
  if (errorMessage.includes('Only') && errorMessage.includes('items were added') || 
      errorMessage.includes('maximum quantity') ||
      errorMessage.includes('availability')) {
    
    // Show per-item notice
    itemNotice = document.createElement('div');
    itemNotice.className = 'cart-item__error notice';
    itemNotice.style.cssText = 'background: #fee; color: #c33; padding: 8px 12px; border-radius: 4px; font-size: 14px; margin-top: 8px;';
    itemNotice.textContent = errorMessage;
    
    // Insert above price
    const priceContainer = cartItem.querySelector('.cart-item__price');
    if (priceContainer) {
      priceContainer.parentNode.insertBefore(itemNotice, priceContainer.nextSibling);
    }
    
    // Auto-hide after 5s
    setTimeout(() => itemNotice?.remove(), 5000);
    
  } else {
    // Fallback for other errors
    alert(`Failed to update: ${errorMessage}`);
  }
  
  // Revert visual changes
  if (cartItem) {
    cartItem.style.opacity = '';
    cartItem.style.pointerEvents = '';
  }
} finally {
    cartUpdateInProgress = false;
  }
}


// ============================================
// Add to Cart - Fetch fresh section
// ============================================

async function addToCartAndUpdate() {
  // After adding to cart, we need fresh HTML because we don't know what was added
  try {
    const response = await fetch('/?section_id=template-slide-out-cart');
    const html = await response.text();
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Update items area
    const newItems = doc.querySelector('[data-cart-items]');
    const currentItems = document.querySelector('[data-cart-items]');
    
    if (newItems && currentItems) {
      currentItems.innerHTML = newItems.innerHTML;
    }
    
    // Update footer
    const newFooter = doc.querySelector('.slide-cart__footer');
    const currentFooter = document.querySelector('.slide-cart__footer');
    
    if (newFooter && currentFooter) {
      currentFooter.innerHTML = newFooter.innerHTML;
    }
    
    // Update cart count
    const cart = await getCart();
    updateCartCount(cart.item_count);
    
  } catch (error) {
    console.error('Error updating cart after add:', error);
  }
}

// ============================================
// Cart Note Updates
// ============================================

async function updateCartNote(note) {
  try {
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note })
    });
  } catch (error) {
    console.error('Error updating note:', error);
  }
}

// ============================================
// Event Delegation
// ============================================

document.addEventListener('DOMContentLoaded', () => {
  
  // Add to cart forms
  const addToCartForms = document.querySelectorAll('[data-add-to-cart-form]');
  
addToCartForms.forEach((form) => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    
    const submitButton = form.querySelector('[data-add-to-cart-button]');
    const originalText = submitButton.textContent;
    const variantId = parseInt(form.querySelector('[name="id"]').value);  // NEW: Track variant
    submitButton.textContent = 'Adding...';
    submitButton.disabled = true;
    
    let inventoryMessage = null;  // NEW: Store message for cart
    
    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: parseInt(form.querySelector('[name="quantity"]')?.value || 1)
          }]
        })
      });
      
      const errorData = await addResponse.json().catch(() => ({}));
      
      // Detect inventory limit & store message
      if (errorData.status === 422 && (
        errorData.message?.includes('Only ') && errorData.message.includes('items were added') ||
        errorData.message?.includes('availability') ||
        errorData.message?.includes('maximum quantity')
      )) {
        inventoryMessage = errorData.message;  // Save for cart display
      } else if (!addResponse.ok) {
        throw new Error(errorData.message || 'Add to cart failed');
      }
      
      // Always refresh & open cart
      await addToCartAndUpdate();
      openSlideCart();
      
      // **NEW**: Add notice to cart item AFTER refresh
      if (inventoryMessage) {
        await showCartItemInventoryNotice(variantId, inventoryMessage);
      }
      
    } catch (error) {
      console.error('Add to cart error:', error);
      alert(`Error adding to cart: ${error.message}`);
    } finally {
      submitButton.textContent = originalText;
      submitButton.disabled = false;
    }
  });
});

// NEW: Show inventory notice on specific cart item
async function showCartItemInventoryNotice(variantId, message) {
  // Wait for cart refresh
  await new Promise(resolve => setTimeout(resolve, 100));
  
  // Find newest cart item by variant ID
  const cartItem = Array.from(document.querySelectorAll('[data-variant-id]'))
    .find(el => parseInt(el.dataset.variantId) === variantId);
    
  if (!cartItem) return;
  
  // Remove existing notices
  cartItem.querySelectorAll('.cart-item__error, .cart-item__inventory-notice').forEach(n => n.remove());
  
  // Create notice (same style as change-qty errors)
  const notice = document.createElement('div');
  notice.className = 'cart-item__error notice';
  notice.style.cssText = `
    background: #fee; color: #c33; padding: 8px 12px; border-radius: 4px; 
    margin: 8px 0; font-size: 14px; border-left: 3px solid #f66;
  `;
  notice.textContent = message;
  
    // Place notice right below .cart-item__price div
    const priceContainer = cartItem.querySelector('.cart-item__price');
    if (priceContainer && priceContainer.parentNode) {
      priceContainer.parentNode.insertBefore(notice, priceContainer.nextSibling);
    }

  
  // Auto-hide 6s
  setTimeout(() => notice.remove(), 6000);
}


  
  // Cart icon toggle
  document.addEventListener('click', (e) => {
    const toggleBtn = e.target.closest('[data-cart-toggle]');
    if (!toggleBtn) return;
   
    
    const slideCart = document.getElementById('slideCart');
    if (!slideCart) return;
    
    const isOpen = slideCart.getAttribute('aria-hidden') === 'false';

    if (isOpen) {
      openSlideCart();
    } else {
      closeSlideCart();
    }
  });
  
  // Close cart drawer
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-slide-cart-close]') || 
        e.target.closest('[data-slide-cart-close]')) {
      closeSlideCart();
    }
  });
  
  // Quantity changes (event delegation for dynamically loaded content)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quantity-change]');
    if (!btn) return;
    
    e.preventDefault();
    
    const lineKey = btn.dataset.lineKey;
    const quantity = parseInt(btn.dataset.quantity);
    
    await changeCartQuantityByKey(lineKey, quantity); 
  });
  
  // Quantity input changes
  document.addEventListener('change', async (e) => {
    if (!e.target.matches('[data-quantity-input]')) return;
    
    const lineKey = e.target.dataset.lineKey;
    const quantity = parseInt(e.target.value);
    
    if (quantity >= 0) {
      await changeCartQuantityByKey(lineKey, quantity);
    }
  });
  
  // Cart note updates (debounced)
  let noteTimeout;
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-cart-note]')) return;
    
    clearTimeout(noteTimeout);
    noteTimeout = setTimeout(() => {
      updateCartNote(e.target.value);
    }, 500);
  });
  
  // Checkout button
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-checkout-button]')) { 
    window.location.href = '/checkout';
  }
});

  
  // ESC key to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSlideCart();
    }
  });
});


// Cart icon toggle
document.addEventListener('click', (e) => {
  const toggleBtn = e.target.closest('[data-cart-toggle]');
  if (!toggleBtn) return;
  
  const slideCart = document.getElementById('slideCart');
  const isOpen = slideCart.getAttribute('aria-hidden') === 'false';
  
  if (isOpen) {
    closeSlideCart();
    toggleBtn.setAttribute('aria-expanded', 'false');
  } else {
    openSlideCart();
    toggleBtn.setAttribute('aria-expanded', 'true');
  }
});
  
// Format Monies
function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || window.money_format || "{{amount}}";

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }

  var match = formatString.match(placeholderRegex);
  if (match) {
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
  }
  return formatString.replace(placeholderRegex, value);
}
Shopify = Shopify || {};
Shopify.formatMoney = formatMoney;